module.exports = __webpack_public_path__ + "static/media/floor3.0d7502c6.png";